import { Component, OnInit } from '@angular/core';
import { CommoditiesTableService } from '../../shared/tables/commodities-table.service';
import { Store } from '@ngrx/store';
import { AppState } from '../../../store';
import { CommoditiesData } from './commodities.data';
import { commodityTableDelete, commodityTableRequest } from '../../../store/commodity-table/commodity-table.actions';
import { AsyncPipe } from '@angular/common';
import {
    MatCell,
    MatCellDef,
    MatColumnDef,
    MatHeaderCell, MatHeaderCellDef,
    MatHeaderRow,
    MatHeaderRowDef,
    MatRow,
    MatRowDef, MatTable
} from '@angular/material/table';
import { MatCheckbox } from '@angular/material/checkbox';
import { MatButton } from '@angular/material/button';
import { MatPaginator } from '@angular/material/paginator';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { MatSort, MatSortHeader } from '@angular/material/sort';
import { MatDialog } from '@angular/material/dialog';
import { CommodityEditComponent } from '../commodity-edit/commodity-edit.component';
import { commodityEditorLoadRequest } from '../../../store/commodity-editor/commodity-editor.actions';
import { ConfirmService } from '../../shared/services/confirm.service';
import { selectCommodityTableSelection } from '../../../store/commodity-table/commodity-table.state';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';

@Component({
    selector: 'app-commodities-table',
    imports: [
    AsyncPipe,
    MatButton,
    MatCell,
    MatCellDef,
    MatCheckbox,
    MatColumnDef,
    MatHeaderCell,
    MatHeaderRow,
    MatHeaderRowDef,
    MatPaginator,
    MatProgressSpinner,
    MatRow,
    MatRowDef,
    MatSort,
    MatTable,
    MatHeaderCellDef,
    MatSortHeader
],
    templateUrl: './commodities-table.component.html',
    styleUrl: './commodities-table.component.scss'
})
export class CommoditiesTableComponent implements OnInit {
    constructor(private store: Store<AppState>, public table: CommoditiesTableService, private dialog: MatDialog,
                private confirmService: ConfirmService) {
    }

    selectionCount$: Observable<number> = this.store.select(selectCommodityTableSelection).pipe(
        map(selection => selection.length)
    );

    dataSource = new CommoditiesData(this.table.currentPageEntries$);

    ngOnInit(): void {
        this.store.dispatch(commodityTableRequest());
    }

    edit(id: string): void {
        this.store.dispatch(commodityEditorLoadRequest({ id }));
        this.dialog.open(CommodityEditComponent, { panelClass: 'modal-editor' });
    }

    delete(): void {
        this.confirmService.confirm(
            $localize`Delete Selected Commodities`,
            $localize`Are you sure you wish to delete the selected commodities?  This action cannot be reversed.`,
            () => this.store.dispatch(commodityTableDelete()));
    }
}
